import React from 'react';

import styled from 'styled-components';

interface Props {
  height: number;
  rating: number;
}

const Wrapper = styled.div<Props>`
  position: relative;
  height: ${(props) => props.height}px;
  width: ${(props) => (props.height / 24) * 133}px;

  svg {
    position: absolute;
    top: 0;
    left: 0;
    height: ${(props) => props.height}px;
    width: ${(props) => (props.height / 24) * 133}px;
    &.front {
      width: ${(props) => ((props.height / 24) * 133 * props.rating) / 5}px;
      path {
        fill: #ffbf51;
      }
    }
  }
`;

interface StarTemplateProps {
  className: string;
  rating?: number;
  fill?: string;
}

const StarTemplate: React.FC<StarTemplateProps> = (props) => {
  const { className, rating = 5, fill = '#E3E5EA' } = props;
  return (
    <svg
      className={className}
      width="135"
      height="24"
      viewBox={`0 0 ${(135 / 5) * rating} 24`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.0377 1.12194C12.2078 0.709255 12.7922 0.709254 12.9623 1.12194L15.8598 8.15379C15.9314 8.32757 16.0944 8.44651 16.2817 8.46167L23.8108 9.07095C24.2528 9.10672 24.4329 9.65749 24.0975 9.94754L18.3543 14.9135C18.2134 15.0353 18.1519 15.2254 18.1947 15.4067L19.9481 22.8267C20.0505 23.26 19.5781 23.6009 19.1991 23.3673L12.7624 19.3988C12.6015 19.2996 12.3985 19.2996 12.2376 19.3988L5.80086 23.3673C5.42185 23.6009 4.94945 23.26 5.05185 22.8267L6.8053 15.4067C6.84814 15.2254 6.78664 15.0353 6.64573 14.9135L0.9025 9.94754C0.567053 9.65749 0.74719 9.10672 1.1892 9.07095L8.71828 8.46167C8.90562 8.44651 9.06864 8.32757 9.14024 8.15379L12.0377 1.12194Z"
        fill={fill}
      />
      <path
        d="M39.0377 1.12194C39.2078 0.709254 39.7922 0.709254 39.9623 1.12194L42.8598 8.15379C42.9314 8.32757 43.0944 8.44651 43.2817 8.46167L50.8108 9.07095C51.2528 9.10672 51.4329 9.65749 51.0975 9.94754L45.3543 14.9135C45.2134 15.0353 45.1519 15.2254 45.1947 15.4067L46.9481 22.8267C47.0505 23.26 46.5781 23.6009 46.1991 23.3673L39.7624 19.3988C39.6015 19.2996 39.3985 19.2996 39.2376 19.3988L32.8009 23.3673C32.4219 23.6009 31.9495 23.26 32.0519 22.8267L33.8053 15.4067C33.8481 15.2254 33.7866 15.0353 33.6457 14.9135L27.9025 9.94754C27.5671 9.65749 27.7472 9.10672 28.1892 9.07095L35.7183 8.46167C35.9056 8.44651 36.0686 8.32757 36.1402 8.15379L39.0377 1.12194Z"
        fill={fill}
      />
      <path
        fill={fill}
        d="M66.0377 1.12194C66.2078 0.709254 66.7922 0.709254 66.9623 1.12194L69.8598 8.15379C69.9314 8.32757 70.0944 8.44651 70.2817 8.46167L77.8108 9.07095C78.2528 9.10672 78.4329 9.65749 78.0975 9.94754L72.3543 14.9135C72.2134 15.0353 72.1519 15.2254 72.1947 15.4067L73.9481 22.8267C74.0505 23.26 73.5781 23.6009 73.1991 23.3673L66.7624 19.3988C66.6015 19.2996 66.3985 19.2996 66.2376 19.3988L59.8009 23.3673C59.4219 23.6009 58.9495 23.26 59.0519 22.8267L60.8053 15.4067C60.8481 15.2254 60.7866 15.0353 60.6457 14.9135L54.9025 9.94754C54.5671 9.65749 54.7472 9.10672 55.1892 9.07095L62.7183 8.46167C62.9056 8.44651 63.0686 8.32757 63.1402 8.15379L66.0377 1.12194Z"
      />
      <path
        d="M93.0377 1.12194C93.2078 0.709254 93.7922 0.709254 93.9623 1.12194L96.8598 8.15379C96.9314 8.32757 97.0944 8.44651 97.2817 8.46167L104.811 9.07095C105.253 9.10672 105.433 9.65749 105.098 9.94754L99.3543 14.9135C99.2134 15.0353 99.1519 15.2254 99.1947 15.4067L100.948 22.8267C101.051 23.26 100.578 23.6009 100.199 23.3673L93.7624 19.3988C93.6015 19.2996 93.3985 19.2996 93.2376 19.3988L86.8009 23.3673C86.4219 23.6009 85.9495 23.26 86.0519 22.8267L87.8053 15.4067C87.8481 15.2254 87.7866 15.0353 87.6457 14.9135L81.9025 9.94754C81.5671 9.65749 81.7472 9.10672 82.1892 9.07095L89.7183 8.46167C89.9056 8.44651 90.0686 8.32757 90.1402 8.15379L93.0377 1.12194Z"
        fill={fill}
      />
      <path
        d="M120.038 1.12194C120.208 0.709254 120.792 0.709254 120.962 1.12194L123.86 8.15379C123.931 8.32757 124.094 8.44651 124.282 8.46167L131.811 9.07095C132.253 9.10672 132.433 9.65749 132.098 9.94754L126.354 14.9135C126.213 15.0353 126.152 15.2254 126.195 15.4067L127.948 22.8267C128.051 23.26 127.578 23.6009 127.199 23.3673L120.762 19.3988C120.602 19.2996 120.398 19.2996 120.238 19.3988L113.801 23.3673C113.422 23.6009 112.949 23.26 113.052 22.8267L114.805 15.4067C114.848 15.2254 114.787 15.0353 114.646 14.9135L108.903 9.94754C108.567 9.65749 108.747 9.10672 109.189 9.07095L116.718 8.46167C116.906 8.44651 117.069 8.32757 117.14 8.15379L120.038 1.12194Z"
        fill={fill}
      />
    </svg>
  );
};

const Star: React.FC<Props> = (props) => {
  return (
    <Wrapper {...props}>
      <StarTemplate className="back" />
      <StarTemplate className="front" rating={props.rating} fill="#FFBF51" />
    </Wrapper>
  );
};

export default Star;
